// #91 — Diff dos "porquês" (5-Whys) para o save granular do NCEditor.
//
// Extraído de NCEditor.handleSave para ficar UNIT-TESTÁVEL (o ponto delicado
// do #91). Recebe:
//   - editedPorques: array de strings dos textareas. Após o fix do #91 tem
//     length max(N, 5) — preserva TODOS os N porquês quando a IA gerou >5
//     (investigação 3-10), com mínimo de 5 slots (UX 5-Whys).
//   - originalPorques: analise.cinco_porques. Pode ser [str] legacy OU
//     [{numero, pergunta, resposta}] v4 (pós shape-migration da Sessão 20).
//
// Retorna [{ campo: 'cinco_porques.{i}.resposta', valor }] SÓ pros porquês
// que mudaram individualmente.
//
// Duas garantias críticas (#91):
//   1. Compara o array COMPLETO (pad a no mínimo 5, mas MANTÉM N>5). Antes o
//      `.slice(0,5)` escondia edições nos porquês 6-10 → não eram salvas.
//   2. Guard por-índice: só envia o que mudou de fato → slot de padding vazio
//      (vazio == vazio) NUNCA é enviado → sem "porquê fantasma" no banco.

function _texto(p) {
  return typeof p === 'object' && p !== null ? (p.resposta || '') : (p || '');
}

export function buildPorquesEdicoes(editedPorques, originalPorques) {
  if (!Array.isArray(editedPorques)) return [];
  const originais = Array.isArray(originalPorques) ? originalPorques : [];

  // Normaliza pra comparação robusta: extrai a `resposta` de dicts v4,
  // mantém strings legacy, pad a no mínimo 5 (mas mantém N>5 = array completo).
  const normalizar = (arr) => {
    const respostas = (arr || []).map(_texto);
    while (respostas.length < 5) respostas.push('');
    return JSON.stringify(respostas);
  };

  // Gate: nada mudou (array completo) → nenhuma edição.
  if (normalizar(editedPorques) === normalizar(originais)) return [];

  const edicoes = [];
  editedPorques.forEach((resposta, i) => {
    // Só os que mudaram individualmente. Padding vazio == original vazio →
    // não entra (anti-fantasma).
    if ((resposta || '') !== _texto(originais[i])) {
      edicoes.push({ campo: `cinco_porques.${i}.resposta`, valor: resposta || '' });
    }
  });
  return edicoes;
}

// #219 Fase 2 — edições da cadeia SALVA inteira, pro "Recalcular causa raiz a
// partir dos porquês" funcionar quando NÃO há edição local pendente.
//
// O beco que isto cura: o backend (reanalisar_porques) exige que a request
// CARREGUE edições de porquês. Quem editava os porquês, SALVAVA (save limpo →
// chip B3 "recalcule para realinhar" acende) e SÓ DEPOIS clicava Recalcular
// caía no aborto "Edite ao menos um porquê" — o diff local fica vazio após o
// save. Re-emitir a cadeia salva satisfaz o backend sem mudá-lo (escreve no-op
// dos mesmos valores; o confirm do recálculo já marca os porquês como
// editados-humano hoje, então a trilha não muda de comportamento).
//
// Slots vazios são pulados (anti-fantasma, espelha buildPorquesEdicoes).
export function buildPorquesEdicoesCadeiaCompleta(porques) {
  if (!Array.isArray(porques)) return [];
  const edicoes = [];
  porques.forEach((p, i) => {
    const resposta = _texto(p);
    if (resposta.trim()) {
      edicoes.push({ campo: `cinco_porques.${i}.resposta`, valor: resposta });
    }
  });
  return edicoes;
}
